export const examAdminSystemSettings = {
  pageTitle: "System Management",
  pageSubtitle: "Entry point for site, AI access, security policy, and audit configuration.",
  infoBanner:
    "System settings are persisted in the database, and changes are written to audit logs.",
  currentConfig: "Current System Configuration",
  platformName: "Platform Name",
  candidatePortalBaseUrl: "Candidate Login URL",
  environment: "Runtime Environment",
  databaseBackend: "Database Backend",
  judgeBackend: "Judge Backend",
  environmentBackend: "Environment Backend",
  aiBackend: "AI Backend",
  assetStorageBackend: "Asset Storage Backend",
  capabilityMatrix: "Platform Capability Matrix",
  roles: "Roles",
  questionTypes: "Question Types",
  paperTypes: "Paper Types",
  judgeLanguages: "Judge Languages",
  environmentQuestionTypes: "Environment-supported Question Types",
  siteSettings: "Site Settings",
  saveSiteSettings: "Save Site Settings",
  uploadLogo: "Upload Site Logo",
  uploadFavicon: "Upload Site Icon",
  logoUploaded: "Site logo uploaded successfully",
  faviconUploaded: "Site icon uploaded successfully",
  logoUploadFailed: "Site logo upload failed",
  faviconUploadFailed: "Site icon upload failed",
  logoUrl: "Site Logo URL",
  logoAssetId: "Site Logo Asset ID",
  faviconUrl: "Site Icon URL",
  faviconAssetId: "Site Icon Asset ID",
  maintenanceMode: "Maintenance Mode",
  aiSettings: "AI Access Settings",
  saveAiSettings: "Save AI Settings",
  endpoint: "Endpoint URL",
  defaultModel: "Default Model",
  apiKey: "API Key (current: {value})",
  securitySettings: "Security Policy",
  saveSecuritySettings: "Save Security Policy",
  requirePasswordChangeOnFirstLogin: "Require password change on first login",
  maxFailedLoginAttempts: "Failed password lock threshold",
  lockMinutes: "Lock duration (minutes)",
  captchaEnabled: "Enable login captcha",
  captchaFailThreshold: "Captcha trigger threshold",
  candidateAllowIpRanges: "Candidate allow IP ranges (one per line, CIDR/single IP)",
  candidateDenyIpRanges: "Candidate deny IP ranges (one per line, CIDR/single IP)",
  adminAllowIpRanges: "Admin allow IP ranges (one per line, CIDR/single IP)",
  adminDenyIpRanges: "Admin deny IP ranges (one per line, CIDR/single IP)",
  candidateAllowMultiLogin: "Allow candidate multi-login",
  staffAllowMultiLogin: "Allow staff multi-login",
  judgeSettings: "Judge Image Configuration",
  judgeSettingsHint:
    "Configure the Python / Node / Go runtime image identifiers for exam-judge. Choose “Apply immediately” to send them with requests, or “Apply after restart” to save the configuration only.",
  saveJudgeSettings: "Save Judge Configuration",
  judgeImagePython: "Python Runtime Image Identifier",
  judgeImageNode: "Node Runtime Image Identifier",
  judgeImageGo: "Go Runtime Image Identifier",
  judgeApplyMode: "Effective Strategy",
  judgeApplyModeImmediate: "Apply immediately",
  judgeApplyModeRestart: "Apply after restart",
  containerHostPortAssignMode: "Container Host Port Allocation Mode",
  containerHostPortAssignModeRandom: "Random",
  containerHostPortAssignModeSequential: "Sequential",
  containerHostPortRangeHint:
    "Host port is allocated only within this range (for practical/attack-defense experience containers).",
  containerHostPortRangeStart: "Host Port Range Start",
  containerHostPortRangeEnd: "Host Port Range End",
  containerHostPortRangeInvalid: "Range end must be greater than or equal to range start",
  storageSettings: "Object Storage",
  saveStorageSettings: "Save Storage Settings",
  storageBackend: "Storage Backend",
  storageBackendLocal: "Local (local)",
  storageBackendOSS: "Alibaba Cloud OSS",
  integrationSettings: "Platform Integration",
  saveIntegrationSettings: "Save Platform Integration Settings",
  integrationHint:
    "Priority: system setting > env fallback > default. Leave a field empty to keep using fallback.",
  integrationEffectiveValue: "Effective value: {value}",
  integrationSource: "Source: {source}",
  integrationFallbackHint: "Use reset to fill the current fallback value into the input.",
  integrationReset: "Reset",
  ossEndpoint: "OSS Endpoint",
  ossRegion: "OSS Region",
  ossBucket: "Bucket",
  ossPrefix: "Object Prefix (optional)",
  ossUseHttps: "Use HTTPS",
  ossAccessKeyId: "AccessKey ID (current: {value})",
  ossAccessKeySecret: "AccessKey Secret (current: {value})",
  siteSaved: "Site settings saved",
  aiSaved: "AI access settings saved",
  securitySaved: "Security policy saved",
  judgeSaved: "Judge image configuration saved",
  storageSaved: "Object storage settings saved",
};
